"use strict";

// css --var ponyfill
if ( ! ( window.CSS && window.CSS.supports && window.CSS.supports( '--fake-var', 0 ) ) ) {
	document.write( '<script src="https://cdn.jsdelivr.net/npm/css-vars-ponyfill@2"><\/script>' );
	document.addEventListener( 'DOMContentLoaded', function() {
		if ( typeof cssVars === 'function' ) {
			cssVars();
		}
	} );
}



(function ($) {

    $.fn.circliful = function (options, callback) {

        var settings = $.extend({
            // These are the defaults.
            foregroundColor: "#3498DB",
            backgroundColor: "#ccc",
            pointColor: "none",
            fillColor: 'none',
            foregroundBorderWidth: 15,
            backgroundBorderWidth: 15,
            pointSize: 28.5,
            fontColor: '#aaa',
            percent: 75,
            animation: 1,
            animationStep: 5,
            icon: 'none',
            iconSize: '30',
            iconColor: '#ccc',
            iconPosition: 'top',
            target: 0,
            start: 0,
            showPercent: 1,
            percentageTextSize: 22,
            textAdditionalCss: '',
            targetPercent: 0,
            targetTextSize: 17,
            targetColor: '#2980B9',
            text: null,
            textStyle: null,
            textColor: '#666',
            multiPercentage: 0,
            percentages: null,
            textBelow: false,
            noPercentageSign: false,
            replacePercentageByText: null,
            halfCircle: false,
            animateInView: false,
            decimals: 0,
            alwaysDecimals: false
        }, options);

        return this.each(function () {
            var circleContainer = $(this);

            mergeDataAttributes(settings, circleContainer.data());

            var percent = settings.percent;
            var iconY = 83;
            var iconX = 100;
            var textY = 110;
            var textX = 100;
            var additionalCss;
            var elements;
            var icon;
            var backgroundBorderWidth = settings.backgroundBorderWidth;

            if (settings.halfCircle) {
                if (settings.iconPosition == 'left') {
                    iconX = 80;
                    iconY = 100;
                    textX = 117;
                    textY = 110;
                } else if (settings.halfCircle) {
                    iconY = 80;
                    textY = 110;
                }
            } else {
                if (settings.iconPosition == 'bottom') {
                    iconY = 124;
                    textY = 95;
                } else if (settings.iconPosition == 'left') {
                    iconX = 80;
                    iconY = 110;
                    textX = 117;
                } else if (settings.iconPosition == 'middle') {
                    if (settings.multiPercentage == 1) {
                        if (typeof settings.percentages == "object") {
                            backgroundBorderWidth = 30;
                        } else {
                            iconY = 110;
                            elements = '<g stroke="' + (settings.backgroundColor != 'none' ? settings.backgroundColor : '#ccc') + '" ><line x1="133" y1="50" x2="140" y2="40" stroke-width="2"  /></g>';
                            elements += '<g stroke="' + (settings.backgroundColor != 'none' ? settings.backgroundColor : '#ccc') + '" ><line x1="140" y1="40" x2="200" y2="40" stroke-width="2"  /></g>';
                            textX = 228;
                            textY = 47;
                        }
                    } else {
                        iconY = 110;
                        elements = '<g stroke="' + (settings.backgroundColor != 'none' ? settings.backgroundColor : '#ccc') + '" ><line x1="133" y1="50" x2="140" y2="40" stroke-width="2"  /></g>';
                        elements += '<g stroke="' + (settings.backgroundColor != 'none' ? settings.backgroundColor : '#ccc') + '" ><line x1="140" y1="40" x2="200" y2="40" stroke-width="2"  /></g>';
                        textX = 170; // To center the percentage exactly in the center.
                        textY = 35;
                    }
                } else if (settings.iconPosition == 'right') {
                    iconX = 120;
                    iconY = 110;
                    textX = 80;
                }
            }

            if (settings.targetPercent > 0) {
                textY = 95;
                elements = '<g stroke="' + (settings.backgroundColor != 'none' ? settings.backgroundColor : '#ccc') + '" ><line x1="75" y1="101" x2="125" y2="101" stroke-width="1"  /></g>';
                elements += '<text text-anchor="middle" x="' + textX + '" y="120" style="font-size: ' + settings.targetTextSize + 'px;" fill="' + settings.targetColor + '">' + settings.targetPercent + (settings.noPercentageSign && settings.replacePercentageByText == null ? '' : '%') + '</text>';
                elements += '<circle cx="100" cy="100" r="69" fill="none" stroke="' + settings.backgroundColor + '" stroke-width="3" stroke-dasharray="450" transform="rotate(-90,100,100)" />';
                elements += '<circle cx="100" cy="100" r="69" fill="none" stroke="' + settings.targetColor + '" stroke-width="3" stroke-dasharray="' + (360 / 100 * settings.targetPercent) + ', 20000" transform="rotate(-90,100,100)" />';
            }

            if (settings.text != null) {
                if (settings.halfCircle) {
                    if (settings.textBelow) {
                        elements += '<text text-anchor="middle" x="100" y="120" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    } else if (settings.multiPercentage == 0) {
                        elements += '<text text-anchor="middle" x="100" y="115" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    } else if (settings.multiPercentage == 1) {
                        elements += '<text text-anchor="middle" x="228" y="65" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    }
                } else {
                    if (settings.textBelow) {
                        elements += '<text text-anchor="middle" x="100" y="190" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    } else if (settings.multiPercentage == 0) {
                        elements += '<text text-anchor="middle" x="100" y="115" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    } else if (settings.multiPercentage == 1) {
                        elements += '<text text-anchor="middle" x="228" y="65" style="' + settings.textStyle + '" fill="' + settings.textColor + '">' + settings.text + '</text>';
                    }
                }
            }

            if (settings.icon != 'none') {
                icon = '<text text-anchor="middle" x="' + iconX + '" y="' + iconY + '" class="icon" style="font-size: ' + settings.iconSize + 'px" fill="' + settings.iconColor + '">&#x' + settings.icon + '</text>';
            }

            if (settings.halfCircle) {
                var rotate = 'transform="rotate(-180,100,100)"';
                circleContainer
                        .addClass('svg-container')
                        .append(
                                $('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 194 186" class="circliful">' +
                                        elements +
                                        '<clipPath id="cut-off-bottom"> <rect x="100" y="0" width="100" height="200" /> </clipPath>' +
                                        '<circle cx="100" cy="100" r="57" class="border" fill="' + settings.fillColor + '" stroke="' + settings.backgroundColor + '" stroke-width="' + backgroundBorderWidth + '" stroke-dasharray="360" clip-path="url(#cut-off-bottom)" transform="rotate(-90,100,100)" />' +
                                        '<circle class="circle" cx="100" cy="100" r="57" class="border" fill="none" stroke="' + settings.foregroundColor + '" stroke-width="' + settings.foregroundBorderWidth + '" stroke-dasharray="0,20000" ' + rotate + ' />' +
                                        '<circle cx="100" cy="100" r="' + settings.pointSize + '" fill="' + settings.pointColor + '" clip-path="url(#cut-off-bottom)" transform="rotate(-90,100,100)" />' +
                                        icon +
                                        '<text class="timer" text-anchor="middle" x="' + textX + '" y="' + textY + '" style="font-size: ' + settings.percentageTextSize + 'px; ' + additionalCss + ';' + settings.textAdditionalCss + '" fill="' + settings.fontColor + '"><tspan class="number">' + (settings.replacePercentageByText == null ? 0 : settings.replacePercentageByText) + '</tspan><tspan class="percent">' + (settings.noPercentageSign || settings.replacePercentageByText != null ? '' : '%') + '</tspan></text>')
                                );
            } else {
                circleContainer
                        .addClass('svg-container')
                        .append(
                                $('<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 194 186" class="circliful">' +
                                        elements +
                                        '<circle cx="100" cy="100" r="57" class="border" fill="' + settings.fillColor + '" stroke="' + settings.backgroundColor + '" stroke-width="' + backgroundBorderWidth + '" stroke-dasharray="360" transform="rotate(-90,100,100)" />' +
                                        '<circle class="circle" cx="100" cy="100" r="57" class="border" fill="none" stroke="' + settings.foregroundColor + '" stroke-width="' + settings.foregroundBorderWidth + '" stroke-dasharray="0,20000" transform="rotate(-90,100,100)" />' +
                                        '<circle cx="100" cy="100" r="' + settings.pointSize + '" fill="' + settings.pointColor + '" />' +
                                        icon +
                                        '<text class="timer" text-anchor="middle" x="' + textX + '" y="' + textY + '" style="font-size: ' + settings.percentageTextSize + 'px; ' + additionalCss + ';' + settings.textAdditionalCss + '" fill="' + settings.fontColor + '"><tspan class="number">' + (settings.replacePercentageByText == null ? 0 : settings.replacePercentageByText) + '</tspan><tspan class="percent">' + (settings.noPercentageSign || settings.replacePercentageByText != null ? '' : '%') + '</tspan></text>')
                                );
            }

            var circle = circleContainer.find('.circle');
            var myTimer = circleContainer.find('.timer');
            var interval = 30;
            var angle = 0;
            var angleIncrement = settings.animationStep;
            var last = 0;
            var summary = 0;
            var oneStep = 0;
            var text = percent;
            var calculateFill = (360 / 100 * percent);

            if (settings.halfCircle) {
                calculateFill = (360 / 100 * percent) / 2;
            }

            if (settings.replacePercentageByText != null) {
                text = settings.replacePercentageByText;
            }

            if (settings.start > 0 && settings.target > 0) {
                percent = settings.start / (settings.target / 100);
                oneStep = settings.target / 100;
            }

            if (settings.animation == 1) {
                if (settings.animateInView) {
                    $(window).scroll(function () {
                        checkAnimation();
                    });
                } else {
                    animate();
                }
            } else {
                circle
                        .attr("stroke-dasharray", calculateFill + ", 20000");

                if (settings.showPercent == 1) {
                    myTimer
                            .find('.number')
                            .text(text);
                } else {
                    myTimer
                            .find('.number')
                            .text(settings.target);
                    myTimer
                            .find('.percent')
                            .text('');
                }
            }

            function animate() {
                var timer = window.setInterval(function () {
                    if ((angle) >= calculateFill) {
                        window.clearInterval(timer);
                        last = 1;
                        if (typeof callback == 'function') {
                            callback.call(this);
                        }
                    } else {
                        angle += angleIncrement;
                        summary += oneStep;
                    }

                    if (angle / 3.6 >= percent && last == 1) {
                        angle = 3.6 * percent;
                    }

                    if (summary > settings.target && last == 1) {
                        summary = settings.target;
                    }

                    if (settings.replacePercentageByText == null) {
                        if (settings.halfCircle) {
                            text = parseFloat((100 * angle / 360) * 2);
                        } else {
                            text = parseFloat((100 * angle / 360));
                        }
                        text = text.toFixed(settings.decimals);
                        if (!settings.alwaysDecimals && (percent == 0 || (percent > 1 && last != 1))) {
                            text = parseInt(text);
                        }
                    }

                    circle
                            .attr("stroke-dasharray", angle + ", 20000");

                    if (settings.showPercent == 1) {
                        myTimer
                                .find('.number')
                                .text(text);
                    } else {
                        myTimer
                                .find('.number')
                                .text(summary);
                        myTimer
                                .find('.percent')
                                .text('');
                    }
                }.bind(circle), interval);
            }

            function isElementInViewport() {
                // Get the scroll position of the page.
                var scrollElem = ((navigator.userAgent.toLowerCase().indexOf('webkit') != -1) ? 'body' : 'html');
                var viewportTop = $(scrollElem).scrollTop();
                var viewportBottom = viewportTop + $(window).height();

                // Get the position of the element on the page.
                var elemTop = Math.round(circle.offset().top);
                var elemBottom = elemTop + circle.height();

                return ((elemTop < viewportBottom) && (elemBottom > viewportTop));
            }

            function checkAnimation() {
                // If the animation has already been started
                if (circle.hasClass('start'))
                    return;

                if (isElementInViewport(circle)) {
                    // Start the animation
                    circle.addClass('start');
                    setTimeout(animate, 250)
                }
            }

            function mergeDataAttributes(settings, dataAttributes) {
                $.each(settings, function (key, value) {
                    if (key.toLowerCase() in dataAttributes) {
                        settings[key] = dataAttributes[key.toLowerCase()];
                    }
                });
            }
        });
    }
}(jQuery));


$(function () {
    $('.scroll-pane').jScrollPane();
    $( window ).resize(function() {
        $('.scroll-pane').jScrollPane();
    });
    $('input').not('input[type="checkbox"]').iCheck({
        checkboxClass: 'icheckbox_flat-blue',
        radioClass: 'iradio_flat-blue',
        labelHover: false
    });
    $('label').unbind('click').click(function (event) {
        // Your code goes here

    });

    // $('select').selectric();

    $('.partners-box').slick({
        arrow: false,
        centerMode: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    $('#partnersBoxBtn').click( function() {
        if (this.getAttribute('data-playpause') == 'pause'){
            $('.partners-box').slick('slickPause');
            $(this).attr('data-playpause', 'play'); 
            this.querySelector('.partners-box-btn__play').style.display = 'block';
            this.querySelector('.partners-box-btn__pause').style.display = 'none';
        } else {
            $('.partners-box').slick('slickPlay');
            $(this).attr('data-playpause', 'pause');
            this.querySelector('.partners-box-btn__play').style.display = 'none';
            this.querySelector('.partners-box-btn__pause').style.display = 'block';
        }  
    });

    $(".slider-box").slick({
        // normal options...
        infinite: true,
        dots: true,
        arrow: true,
        autoplay: true
    });
    $('#sliderBoxBtn').click( function() {
        if (this.getAttribute('data-playpause') == 'pause'){
            $('.slider-box').slick('slickPause');
            $(this).attr('data-playpause', 'play'); 
            this.querySelector('.slider-box-btn__play').style.display = 'block';
            this.querySelector('.slider-box-btn__pause').style.display = 'none';
        } else {
            $('.slider-box').slick('slickPlay');
            $(this).attr('data-playpause', 'pause');
            this.querySelector('.slider-box-btn__play').style.display = 'none';
            this.querySelector('.slider-box-btn__pause').style.display = 'block';
        }  
    });


    var body = $('body, html');


    // $('.item-list-icon').find('a').fancybox();
    //$("*").find("[data-lightbox='roadtrip']").fancybox();


    $('*[data-target="keyboard"]').find('.letter').on('click', function (e) {
        $(this).parent('.keyboard-letters').find('.letter').removeClass('active');
        $(this).addClass('active');
    });
    
    var zoom = 1;
    var width = 100;

    function bigger() {
        zoom = zoom + 0.1;
        width = 100 / zoom;
        document.body.style.transformOrigin = "left top";
        document.body.style.transform = "scale(" + zoom + ")";
        document.body.style.width = width + "%";
    }
    function smaller() {
        zoom = zoom - 0.1;
        width = 100 / zoom;
        document.body.style.transformOrigin = "left top";
        document.body.style.transform = "scale(" + zoom + ")";
        document.body.style.width = width + "%";
    }
    $('#disableUtils').find('a').on('click', function (e) {
        e.preventDefault();
        var buttonType = $(this).attr('data-event');
        var fontSizeMaster = $('body, html');
        

        if (buttonType === 'lowercase') {
            fontSizeMaster.animate({'font-size': '-=1px'}, 200, function () {
                setCookie('fontsize', fontSizeMaster.css('font-size'), 1);
            });
            // smaller();
        } else if (buttonType === 'uppercase') {
            fontSizeMaster.animate({'font-size': '+=1px'}, 200, function () {
                setCookie('fontsize', fontSizeMaster.css('font-size'), 1);
            });
            // bigger();
        } else if (buttonType === 'normalizecase') {
            fontSizeMaster.animate({'font-size': '10px'}, 200, function () {
                setCookie('fontsize', fontSizeMaster.css('font-size'), 1);
            });
            // document.body.style.transform = "scale(1)";
            // document.body.style.width = "100%";
            // zoom = 1;
            // width = 100;

        } else if (buttonType === 'disablefacilities') {
            console.log('kontrast');
        }
    });


    $('.pane-header-departments a').click(function (e) {
        e.preventDefault();
        $(this).tab('show')
    });

    $('.pane-header-department-section a').click(function (e) {
        e.preventDefault();
        $(this).tab('show')
    });

    $('.intro-js').each(function () {
        if ($(this).text().length > 240) {
            var link = $(this).find('a');
            if (link[0]) {
                $(this).html($(this).text().substring(0, 240) + '...' + link[0].outerHTML);
            }
        }
    });

    $('.box-index-sidebar').find('.input-default').on('click', function (e) {
        e.preventDefault();
        var list = $('#indexList');

        function checkVisibilityLetter() {
            $('.indexed-box').each(function () {
                var ifShowItem = 0;

                $(this).find('a').each(function () {
                    if ($(this).css('display') == 'block') {
                        ifShowItem++;
                    }
                });
                if (ifShowItem > 0) {
                    $(this).prev('.hdl-letter').css('display', 'block');
                    $(this).prev('.hdl-letter').animate({'opacity': '1'}, 200);
                } else {
                    $(this).prev('.hdl-letter').animate({'opacity': '0'}, 200, function () {
                        $(this).css('display', 'none');
                    });

                }
            });
        }

        $(this).keyup(function (e) {
            var val = $(this).val().toLowerCase();
            $(list).find('.indexed-item').css({'opacity': '0', 'display': 'none'});

            if (val == '') {
                $(list).find('.indexed-item').css({'opacity': '1', 'display': 'block'});
            } else {
                $(list).find("*[data-search*='" + val + "']").css('display', 'block');
                $(list).find("*[data-search*='" + val + "']").animate({'opacity': '1'}, 200, function () {
                });


            }
            checkVisibilityLetter();
        });
    });


    $('.sub-nav-mobile').on('click', function (e) {
        e.preventDefault();
        var collapseMenu = $(this).next('.nav-left');
        if (collapseMenu.hasClass('isActive')) {
            collapseMenu.removeClass('isActive');
        } else {
            collapseMenu.addClass('isActive');
        }
    });

    $('.box-accordion-menu .btn-toggle').on('click', function (e) {
        e.preventDefault();

        $(this).next().fadeToggle(400);
    });

    $('.content-article').find('.toggle-related').on('click', function (e) {
        e.preventDefault();
        var preloader = '<span style="width: 50px;  height: 50px;  margin: 20px;  display: inline-block;"><svg version="1.1" id="L9" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" ' +
        '    viewBox="0 0 100 100" enable-background="new 0 0 0 0" xml:space="preserve"> '+
        '      <path fill="#0b2e4e" d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50"> '+
        '        <animateTransform  '+
        '           attributeName="transform"  '+
        '           attributeType="XML"  '+
        '           type="rotate" '+
        '           dur="1s"  '+
        '           from="0 50 50" '+
        '           to="360 50 50"  '+
        '           repeatCount="indefinite" /> '+
        '    </path> '+
        '</svg></span>';
        var toggleElement = $(this).next('.item-related');
        $('.content-article').find('.item-related').not(toggleElement).slideUp(200);
        $('.content-article').find('.toggle-related').removeClass('active');
        $(this).addClass('active');
        if(toggleElement.html().length == 0 && (id =$(this).attr('data-getId'))){
            toggleElement.html(preloader); 
            $.post('/relateditem', {'id': id}, function (response) {
                if (response.status && response.status == 'success') {
                    toggleElement.html(response.text);
                }
            });
        }
        $(toggleElement).slideToggle(200);

    });

    var $box = $('#maps-main-map').find('area');

    $box.hover(
            function (e) {
                var tooltip = $('#map-main-box').find('.tooltip');
                var posis = $('#map-main-box').offset();
                $(tooltip).text($(this).attr('data-tooltip'));
                $(tooltip).css({'top': (e.pageY - posis.top), 'left': (e.pageX - posis.left), 'display': 'block'});
                $(tooltip).animate({'opacity': 1}, 200);
            },
            function (e) {
                $('#map-main-box').find('.tooltip').css({'opacity': 0, 'display': 'none'});
            }
    );

    var splitHash = '';
    if (window.location.hash) {
        splitHash = window.location.hash;
        if (splitHash == '#departmentsContentClinic') {
            $('.pane-departments').find('.tab-pane-item').toggleClass('active');
            $('.pane-departments').find('.tab-pane-content').toggleClass('active');
        }
    }


//cookies handler
    function setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + "; " + expires + "; path=/";
    }

    function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ')
                c = c.substring(1);
            if (c.indexOf(name) == 0)
                return c.substring(name.length, c.length);
        }
        return "";
    }


    function checkCookie(font) {
        var cookie = getCookie(font);
        if (cookie != "") {
            $('body, html').css({'font-size': cookie});
        }
    }

    checkCookie("fontsize");




    // checking themeLetterSpacing cookie
    const themeLetterSpacingCookie = getCookie('themeLetterSpacing');
    const letterSpacingStyles = '*{line-height: 1.5 !important;letter-spacing: 0.12em !important;word-spacing: 0.16em !important;}p{margin-bottom: 2em !important;}';
    const styles2 = document.createElement('style');

    if ( themeLetterSpacingCookie ) {
		if ( themeLetterSpacingCookie === 'true' ) {	
            styles2.textContent = letterSpacingStyles;
            document.head.appendChild(styles2);
            document.body.classList.add( 'bigger-spacing' );
		} else {			
            styles2.textContent = '';
            document.head.appendChild(styles2);
			document.body.classList.remove( 'bigger-spacing' );
		}
	}

    document.querySelector('#changeLetterSpacing').addEventListener('click', function() {
        document.body.classList.toggle( 'bigger-spacing' );
        if (document.body.classList.contains( 'bigger-spacing' )) {
            styles2.textContent = letterSpacingStyles;
            document.head.appendChild(styles2);
			setCookie( 'themeLetterSpacing', 'true', 365 );
        } else {
            styles2.textContent = '';
            document.head.appendChild(styles2);
			setCookie( 'themeLetterSpacing', 'false', 365 );
        }
    })


    // checking themeColors cookie
	const themeColorCookie = getCookie( 'themeColors' );
    const stylesDark = ':root{--colorBlack: #FFFB00;--colorWhite: #000000;--colorWhite2: #FFFB00;--color1: #FFFB00;--color2: #2b2b2b;--color2v2: #FFFB00;--color3: #000000;--color3v2: #FFFB00;--color4: #FFFB00;--color4v2: #000000;--color5: #404040;--color5v2: #FFFB00;--color6: #2b2b2b;--color6v2: #ffffff;--color6v3: #FFFB00;--color7: #FFFB00;--color7v2: #000000;--color8: #FFFB00;--color8v2: #000000;--color9: #ffab00;--color9v2: #000000;--color10: #FFFB00;--color10v2: #000000;--color11: #FFFB00;--color12: #FFFB00;--color13: #FFFB00;--color14: #FFFB00;--color15: #2b2b2b;--color16: #FFFB00;--color17: #000000;--color18: #FFFB00;--color19: #000000;--color19v2: #FFFB00;--color20: #FFFB00;--color21: #FFFB00;--color22: #ffab00;--color23: #FFFB00;}';
    const stylesLight = ':root{--colorBlack: #000000;--colorWhite: #ffffff;--colorWhite2: #ffffff;--color1: #e6e6e6;--color2: #f3f3f3;--color2v2: #f3f3f3;--color3: #c7e4ff;--color3v2: #c7e4ff;--color4: #667985;--color4v2: #667985;--color5: #0b2e4e;--color5v2: #0b2e4e;--color6: #0b2e4e;--color6v2: #0b2e4e;--color6v3: #0b2e4e;--color7: #0b2e4e;--color7v2: #0b2e4e;--color8: #09243f;--color8v2: #09243f;--color9: #0b2e4e;--color9v2: #0b2e4e;--color10: #003576;--color10v2: #003576;--color11: #f8f8f8;--color12: #a2a2a2;--color13: #2a827c;--color14: #c7c7c7;--color15: #f0f8ff;--color16: #e9ebee;--color17: #767676;--color18: #747474;--color19: #3b5998;--color19v2: #3b5998;--color20: #457ca1;--color21: #00968b;--color22: #2591d8;--color23: #7dd4ff;}';
    const styles = document.createElement('style');

	if ( themeColorCookie ) {
		if ( themeColorCookie === 'darkTheme' ) {	
            styles.textContent = stylesDark;
            document.head.appendChild(styles);
            document.body.classList.add( 'dark-theme' );
		} else {			
            styles.textContent = stylesLight;
            document.head.appendChild(styles);
			document.body.classList.remove( 'dark-theme' );
		}
	}

        
    function changeSpanInlineColor(spans, spanColorsArray) {
        for (var i=0; i<spans.length; i++) {
            var initialColor = spanColorsArray[i];
            if (document.body.classList.contains('dark-theme')) {
                if (spans[i].style.color != '') {
                    spans[i].style.color = '#FFFB00';
                }
            } else {
                if (spans[i].style.color != '') {
                    spans[i].style.color = initialColor;
                }
            }       
        }       
    }       
    const allSpan = document.querySelectorAll( 'span' );
	const allSpanColors = [];
	for ( var i = 0; i < allSpan.length; i++ ) {
		allSpanColors.push( allSpan[ i ].style.backgroundColor );
	}
    changeSpanInlineColor(allSpan, allSpanColors);


    function changeTrInlineColor(trs, trColorsArray) {
        for (var i=0; i<trs.length; i++) {
            var initialColor = trColorsArray[i];
            if (document.body.classList.contains('dark-theme')) {
                if (trs[i].style.backgroundColor != '') {
                    trs[i].style.backgroundColor = '#404040';
                }
            } else {
                if (trs[i].style.backgroundColor != '') {
                    trs[i].style.backgroundColor = initialColor;
                }
            }       
        }       
    }       
    const allTr = document.querySelectorAll( 'tr' );
	const allTrColors = [];
	for ( var i = 0; i < allTr.length; i++ ) {
		allTrColors.push( allTr[ i ].style.backgroundColor );
	}
    changeTrInlineColor(allTr, allTrColors);


    function changeTableInlineColor(tables, tablesBgArray) {
        for (var i=0; i<tables.length; i++) {
            var initialColor = tablesBgArray[i];
            if (document.body.classList.contains('dark-theme')) {
                if (tables[i].style.backgroundColor != '') {
                    tables[i].style.backgroundColor = '#000000';
                }
            } else {
                if (tables[i].style.backgroundColor != '') {
                    tables[i].style.backgroundColor = initialColor;
                }
            }       
        }    
    }
    const allTables = document.querySelectorAll( 'table' );
	const allTablesColors = [];
	for ( var i = 0; i < allTables.length; i++ ) {
		allTablesColors.push( allTables[ i ].style.backgroundColor );
	}
    changeTableInlineColor(allTables, allTablesColors);


    document.querySelector('#changeColor').addEventListener('click', function() {
        document.body.classList.toggle( 'dark-theme' );
        if (document.body.classList.contains( 'dark-theme' )) {
            styles.textContent = stylesDark;
            document.head.appendChild(styles);
			setCookie( 'themeColors', 'darkTheme', 365 );
            changeSpanInlineColor(allSpan, allSpanColors);
            changeTrInlineColor(allTr, allTrColors);
            changeTableInlineColor(allTables, allTablesColors);
        } else {
            styles.textContent = stylesLight;
            document.head.appendChild(styles);
			setCookie( 'themeColors', 'lightTheme', 365 );
            changeSpanInlineColor(allSpan, allSpanColors);
            changeTrInlineColor(allTr, allTrColors);
            changeTableInlineColor(allTables, allTablesColors);
        }
    })

    


    

 


    if (getCookie('cookieAccept') == false) {
        $('#cookiePane').css('display', 'block');
    } else {
        $('#cookiePane').css('display', 'none');
    }

    $('#cookieBtnClose').on('click', function (e) {
        e.preventDefault();
        $('#cookiePane').css('display', 'none');
        setCookie('cookieAccept', 'active', 90);
    });


//    if (getCookie('cookieRodo') == false) {
//        $('#popup_rodo').css('display', 'flex');
//    } else {
        $('#popup_rodo').css('display', 'none');
//    }

    $('.close_popup_rodo').on('click', function(e) {
        e.preventDefault();
        $('#popup_rodo').css('display', 'none');
        setCookie('cookieRodo', 'active', 90);
    });
/*
    $("#alert_popup .close").on('click', function(e) {
        $("#alert_popup").fadeOut();
        setCookie('cookieDepartment', 'active', 180);
    });
*/
    // $('#jPopupGoToDepartment').on('click', function(e) {
    //     e.preventDefault();
    //     e.stopPropagation();
    //     $("#alert_popup").fadeOut();
    //     setCookie('cookieDepartment', 'active', 180);
    //     if ($(this).attr('href')) {
    //         document.location = $(this).attr('href');
    //     }
    // });

    // $('#alert_popup').on('click', function(e) {
    //     $("#alert_popup").fadeOut();
    //     setCookie('cookieDepartment', 'active', 180);
    // });

    // if ($('#alert_popup').length > 0) {
    //     if (getCookie('cookieDepartment') == false) {
    //         $('#alert_popup').css('display', 'block');
    //     } else {
    //         $('#alert_popup').css('display', 'none');
    //     }
    // }

    $(".navigation-main-box").sticky({topSpacing: 0});


//Form validation

//Form AJAX
    $('.form-horizontal').find('.submit-form').on('click', function (e) {

        e.preventDefault();
        var btn = $(this);

        btn.css('background-color', 'rgb(144, 144, 144)');
        btn.attr("disabled", true);
        var form = $('.form-horizontal');
        var formData = form.serializeArray();

        var URL = form.attr('action');
        //console.log('test');

        $.post(URL,
                formData,
                function (response, textStatus, jqXHR) {
                    //console.log(data);
                    if (response.status == 'success') {
                        form.fadeOut(200);
                        setTimeout(function () {
                            form.next('.sent-message').fadeIn(200);
                            var posisitonDest = $(form).offset().top - 96;
                            body.stop().animate({scrollTop: posisitonDest + 'px'}, '500');
                        }, 200);
                    } else {
                        $('.sr-error').remove();
                        btn.css('background-color', '#f70404');
                        btn.attr("disabled", false);
                        form.find('input').css('border-color', "#34c5ff");
                        form.find('input').css('background-color', "#ffffff");
                        form.find('textarea').css('border-color', "#34c5ff");
                        form.find('textarea').css('background-color', "#ffffff");
                        form.find('.tooltip').hide(100);
                        $('[for="department"]').before('<label class="sr-only sr-error" tabindex="0">uzupełnij wszystkie wymagane pola tekstowe</label>');
                        $('.box-form .sr-error').focus();
                        $.each(response.fiedsErrors, function (i, item) {
                            var elem = form.find('*[name="' + i + '"]');
                            
                            

                            elem.css({'border-color': '#f70404', 'background-color': '#fec2c2'});

                            if (i == 'captchaCode') {
                                elem = form.find('#captchaCode-input');
                            }

                            for (key in item) {
                                if (item.hasOwnProperty(key)) {
                                    var value = item[key];
                                    elem.closest('.box-clean-form').prev('.tooltip').text(value).show(300);
                                }
                            }
                        });
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
        });

    });

    $('.form-horizontal').find('input').on('keypress', function (e) {
        $(this).prev('.btn-clean').show(200);
    });

    $('.form-horizontal').find('textarea').on('keypress', function (e) {
        $(this).prev('.btn-clean').show(200);
    });

    $('.btn-clean').on('click', function (e) {
        e.preventDefault();
        $(this).next().val('');
        $(this).next().css({'border-color': '#34c5ff'});
        $(this).hide(300);
        $(this).prev('.tooltip').hide(200);
    });


    $('.toggle-more-btn').on('click', function (e) {
        e.preventDefault();
        $(this).closest('label').find('.more').slideToggle(200);

        var text = $(this).hasClass('open');
        $(this).removeClass("close open").addClass(text ? "close" : "open");
    });

    $('.toggle-more-job-btn').on('click', function (e) {
        e.preventDefault();
        $('.clause_more').slideToggle(200);

        var test = $(this).hasClass('open');
        $(this).removeClass("close open").addClass(test ? "close" : "open");
        $(this).text(test ? "więcej" : "mniej")
    });

    if (window.print) {
        if($('#departmentId').attr('data-department') && $('#departmentId').attr('data-department')!= 2644){
            $('.box-print').removeClass('disabled').addClass('active');
            $('.btn-print').on('click', function (e) {
                e.preventDefault();
                window.print();
            });
        }
    }

//handling external links (issue tinymce)
    $('.content-article').find('a[href^="http://"]').attr('target', '_blank');
    $('.content-article').find('a[href^="https://"]').attr('target', '_blank');


//svg ajax load and animation
    if ($('#iconEnvelope').length) {
        var d = new Snap('#iconEnvelope');

        Snap.load('images/svg/envelope.svg', function (response) {
            var envelope = response;
            var g = envelope.select("path");
            d.append(g);    //Now we add the SVG element to the page

            var moveElems = g;
            var dx = moveElems.getBBox().d; // Get its initial coordinates
            animateEnvelope(moveElems, dx); // Send it to be infinitely animated

            function animateEnvelope(moveElems, dx) {
                moveElems.attr({transform: 't120 -200'});
                var deg = -30;

                moveElems.stop().animate({transform: 't120 60'}, 400, function () {
                    moveElems.stop().animate({transform: 't120 30'}, 200, function () {
                        moveElems.stop().animate({transform: 't120 60'}, 200, function () {
                            moveElems.stop().animate({transform: 't120 50'}, 200, function () {
                                moveElems.stop().animate({transform: 't120 60'}, 200, function () {
                                    moveElems.animate({transform: 't120 60 r' + deg + ' 0 62'}, 800, function () {
                                        moveElems.animate({transform: 't170 60 r' + deg + ' 0 62'}, 400, function () {
                                            moveElems.animate({transform: 't-200 60 r' + deg + ' 0 62'}, 1000, function () {
                                                animateEnvelope(moveElems, dx);
                                            });
                                        });
                                    });
                                });
                            });
                        });
                    });
                });
            }

        });
    }
})
        ;


(function (window, document, undefined) {

    // helper functions

    var trim = function (str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    };

    var hasClass = function (el, cn) {
        return (' ' + el.className + ' ').indexOf(' ' + cn + ' ') !== -1;
    };

    var addClass = function (el, cn) {
        if (!hasClass(el, cn)) {
            el.className = (el.className === '') ? cn : el.className + ' ' + cn;
        }
    };

    var removeClass = function (el, cn) {
        el.className = trim((' ' + el.className + ' ').replace(' ' + cn + ' ', ' '));
    };

    var hasParent = function (el, id) {
        if (el) {
            do {
                if (el.id === id) {
                    return true;
                }
                if (el.nodeType === 9) {
                    break;
                }
            } while ((el = el.parentNode));
        }
        return false;
    };

    // normalize vendor prefixes

    var doc = document.documentElement;

    var transform_prop = window.Modernizr.prefixed('transform'),
            transition_prop = window.Modernizr.prefixed('transition'),
            transition_end = (function () {
                var props = {
                    'WebkitTransition': 'webkitTransitionEnd',
                    'MozTransition': 'transitionend',
                    'OTransition': 'oTransitionEnd otransitionend',
                    'msTransition': 'MSTransitionEnd',
                    'transition': 'transitionend'
                };
                return props.hasOwnProperty(transition_prop) ? props[transition_prop] : false;
            })();

    window.App = (function () {

        var _init = false, app = {};

        var inner = document.getElementById('inner-wrap'),
                nav_open = false,
                nav_class = 'js-nav';


        app.init = function () {
            if (_init) {
                return;
            }
            _init = true;

            var closeNavEnd = function (e) {
                if (e && e.target === inner) {
                    document.removeEventListener(transition_end, closeNavEnd, false);
                }
                nav_open = false;
            };

            app.closeNav = function () {
                if (nav_open) {
                    // close navigation after transition or immediately
                    console.log(inner);
                    var duration = (transition_end && transition_prop) ? parseFloat(window.getComputedStyle(document.getElementById('inner-wrap'), '')[transition_prop + 'Duration']) : 0;
                    if (duration > 0) {
                        document.addEventListener(transition_end, closeNavEnd, false);
                    } else {
                        closeNavEnd(null);
                    }
                }
                removeClass(doc, nav_class);
            };

            app.openNav = function () {
                if (nav_open) {
                    return;
                }
                addClass(doc, nav_class);
                nav_open = true;
            };

            app.toggleNav = function (e) {
                if (nav_open && hasClass(doc, nav_class)) {
                    app.closeNav();
                } else {
                    app.openNav();
                }
                if (e) {
                    e.preventDefault();
                }
            };

            // open nav with main "nav" button
            document.getElementById('nav-open-btn').addEventListener('click', app.toggleNav, false);

            // close nav with main "close" button
            document.getElementById('nav-close-btn').addEventListener('click', app.toggleNav, false);

            $('#mainNav').find('a').on('click', function (e) {
                app.toggleNav();
            });

            // close nav by touching the partial off-screen content
            document.addEventListener('click', function (e) {
                if (nav_open && !hasParent(e.target, 'nav')) {
                    e.preventDefault();
                    app.closeNav();
                }
            },
                    true);
            addClass(doc, 'js-ready');
        };
        return app;

    })();

    if (window.addEventListener) {
        window.addEventListener('DOMContentLoaded', window.App.init, false);
    }

})(window, window.document);


/* skrypt do listy z personelem, jak jest wiecej jak 2 osoby, to układa ich 2 w kolumnie*/

$(function() {
  var ulListPersonel = $(".namePerson ul");
  var liElement = ulListPersonel.find("li");

  function columnPersonel(){
    ulListPersonel.each(function(el) {
      if ($(this).find("li").length > 2 && $(window).width() > 600) {
        $(this).css({
          '-webkit-column-count' : '2',
          '-moz-column-count' : '2',
          'column-count' : '2',
          '-webkit-column-gap' : '45px',
          '-moz-column-gap' : '45px',
          'column-gap' : '45px'
        });
      }
    });
  }
  columnPersonel();

  $(window).resize(function(){
    if ( $(window).width() < 600 ) {
      ulListPersonel.each(function(el) {
          $(this).css({
            '-webkit-column-count' : '1',
            '-moz-column-count' : '1',
            'column-count' : '1'
          });
      });
    }else {
      columnPersonel();
    }
  });

});





// $(document).ready(function() {
//     $(window).on('click', function(e) {
//         $("#alert_popup").fadeOut();
//     });
// })

$(document).ready(function() {


    $( ".main-container table" ).each(function() {
        var table = $(this);

        if(table.parent().is("p,h1,h2,h3,h4,h5,h6,span,strong,em,a")){
            table.unwrap();
        }

        table.wrap( '<div class="scrolled_table_outer"><div class="scrolled_table"><div class="scrolled_table_inner"></div></div></div>' );
    });



  })

//   var popup = document.getElementById("alert_popup");

//   window.onclick = function(event) {
//     if (event.target == popup) {
//       popup.style.display = "none";
//     }
//   }